<template>
  <span>
    <template v-if="path.length < 30">
      {{ path }}
    </template>
    <template v-else>
      <v-menu v-model="popover"
              max-width="400"
              transition="slide-y-transition"
              :close-on-content-click="false"
              :nudge-width="200"
              offset-x>
        <template v-slot:activator="{ on, attrs }">
          <span v-on="on" style="cursor: pointer">{{ pathParts[0] }} ... {{ pathParts[1] }}</span>
        </template>
        <v-card>
          <v-card-text>
            {{ path }}
          </v-card-text>
        </v-card>
      </v-menu>
    </template>
  </span>
</template>

<script>
export default {
  name: 'PathInfo',
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      popover: false,
    }
  },
  computed: {
    pathParts () {
      return [
        this.path.substr(0, 12),
        this.path.substr(-12, 12)
      ]
    },
  },
}
</script>
